import { ShipmentStopsReport } from '@api/order-reporting/types/ShipmentStopsReport';
import { ShipmentStopsGridData } from '@pages/reporting-pages/shipment-stops/types/ShipmentStopsGridData';
import { format, parseISO } from 'date-fns';
import { isMinDate } from 'components/global/utils';



export const convertToGridData = (apiData: ShipmentStopsReport[] | undefined | null): ShipmentStopsGridData[] | null => {
	if (!apiData) return null;

	let gridData: ShipmentStopsGridData[] = [];
	if (apiData.length === 0)
		return gridData;
	

	gridData = apiData.map(x => ({
		...x,
		plannedTimes: `${
				x.plannedArrival && !isMinDate(x.plannedArrival) ? format(parseISO(x.plannedArrival), 'HH:mm') : ''
			} - ${
				x.plannedDeparture && !isMinDate(x.plannedDeparture) ? format(parseISO(x.plannedDeparture), 'HH:mm') : ''
			}`,
		realTimes: `${
				x.realArrival && !isMinDate(x.realArrival) ? format(parseISO(x.realArrival), 'HH:mm') : ''
			} - ${
				x.realDeparture && !isMinDate(x.realDeparture) ? format(parseISO(x.realDeparture), 'HH:mm') : ''
			}`,
	}));

	return gridData
}